module.exports = __webpack_public_path__ + "c00207172f9b1de6dabefc7c16741ebe.svg";